// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"54a50ba9","442":"3db891c5","547":"baa2a57f","723":"a3658f10","811":"ac6ed5c8"}[chunkId] + ".chunk.js";
};